import InfoAndSlideShow from "../components/Sections/InfoAndSlideShow";
const Contact = () => {
    return (
        <div style={{ paddingTop: "99px", minHeight: "calc(100vh - 100px)" }}>
            <InfoAndSlideShow section={2} />
        </div>
    );
};

export default Contact;
